module.exports = __webpack_public_path__ + "img/Support-skill-304.aa9045de.png";